<section class="cmn-innerpage-wrapper client-details">
  <div class="head">
    <!-- <div class="search-wrapper">
    </div> -->

    <div class="title-wrapper" *ngIf="logTab === 1">
      <p>Expense Logs</p>
    </div>
    <div class="form-wrapper" *ngIf="logTab === 1">
      <mat-form-field>
        <mat-date-range-input [rangePicker]="picker" [dateFilter]="dateFilter">
          <input
            matStartDate
            placeholder="Start date"
            formControlName="startDate"
            (dateInput)="onDateChange($event, 'start')"
          />
          <input
            matEndDate
            placeholder="End date"
            formControlName="endDate"
            (dateInput)="onDateChange($event, 'end')"
          />
        </mat-date-range-input>
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker"
        ></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>
  </div>

  <div>
    <div class="common-noimage-tab-wrapper">
      <mat-tab-group
        animationDuration="0ms"
        (selectedIndexChange)="onTabChange($event)"
      >
        <!-- Mat Tab One -->
        <div *ngIf="canExpenseStationaryItems$ | async">
          <mat-tab>
            <ng-template mat-tab-label>
              <h2 class="leave-tab-title">Expenses</h2>
            </ng-template>
            <div class="client-cmn-inner-content-wrapper">
              <ag-grid-angular
                style="width: 100%"
                [rowData]="rowData"
                [columnDefs]="columnDefs"
                [defaultColDef]="defaultColDef"
                [rowSelection]="rowSelection"
                [suppressRowClickSelection]="true"
                [pagination]="true"
                [paginationPageSize]="paginationPageSize"
                [paginationPageSizeSelector]="paginationPageSizeSelector"
                [class]="themeClass"
              />
            </div>
          </mat-tab>
        </div>
        <!-- Mat Tab Two -->
        <div *ngIf="canExpenseLogsStationaryItems$ | async">
          <mat-tab>
            <ng-template mat-tab-label>
              <h2 class="leave-tab-title">Logs</h2>
            </ng-template>
            <div class="client-cmn-inner-content-wrapper">
              <ag-grid-angular
                style="width: 100%"
                [rowData]="LogrowData"
                [columnDefs]="logcolumnDef"
                [defaultColDef]="defaultLogColDef"
                [rowSelection]="rowSelection"
                [suppressRowClickSelection]="true"
                [pagination]="true"
                [paginationPageSize]="paginationPageSize"
                [paginationPageSizeSelector]="paginationPageSizeSelector"
                [class]="themeClass"
              />
            </div>
          </mat-tab>
        </div>
      </mat-tab-group>
    </div>
  </div>
</section>
